import React, { memo, useContext } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styles from './assets/styles/formatTicket.styles'
import clsx from 'clsx'
import { PickerDispatch } from '../app/contexts/picket.context'

const useStyles = makeStyles(styles)

function FormatTicket({
    image,
    active,
    primaryText,
    secondaryText,
    index,
    changeFade,
    setVisibleFormat
}) {
    const dispatch = useContext(PickerDispatch)
    const setFormat = format => {
        setVisibleFormat(format)
        changeFade(() => dispatch({ type: 'SET_FORMAT', payload: format }))
    }
    const classes = useStyles()
    return (
        <div onClick={() => setFormat(index)} className={clsx(classes.root, active && classes.active)} >
            <span className={classes.imgWrap} >
                <img className={classes.img} src={image} alt={primaryText} />
            </span>
            <span className={classes.wrap} >
                <p className={classes.primary} >{primaryText}</p>
                <p className={classes.secondary} >{secondaryText}</p>
            </span>
        </div>
    )
}

export default memo(FormatTicket)